<template>
  <data-table :has-results="values.length > 0">
    <template slot="table-header">
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>Stats</th>
        <th class="text-right">Created At</th>
      </tr>
    </template>
    <template slot="table-body">
      <tr v-for="template in values" :key="`campaign-stats-templates-tr-${template.id}`">
        <td>{{ template.id }}</td>
        <td>
          <router-link :to="{ name: 'templates-single', params: { id: template.id } }">{{ template.name }}</router-link>
        </td>
        <td>
          <stats-column :stats="template.stats" :loaded="statsLoaded"/>
        </td>
        <td class="text-right">{{ template.created_at }}</td>
      </tr>
    </template>
  </data-table>
</template>

<script>
import Base from '@/views/pages/campaigns/partials/stats/Base'

export default {
  name: 'CampaignStatsOffers',
  extends: Base
}
</script>
